export default function assessChoices (componentElement, props, data, obj) {
    const result = {};
    if(props.autoPoint && data.answer) {
        const total_choice_points = data.total_choice_points ?? 0;
        if(total_choice_points){
            let assess_point = 0;
            data.answer.forEach(x => {
                const i = data.choices.indexOf(x);
                assess_point += data.choice_points[i];
            });
            result.assess_point = assess_point;
        } else {
            if(data.correct_answer && data.answer.length && data.answer.length == data.correct_answer.length) {
                const matched = data.answer.filter(x => {
                    return data.correct_answer.includes(x);
                })
                result.assess_point = matched.length == data.correct_answer.length ? data.max_point : 0;
            } else {
                result.assess_point = 0;
            }    
        }
    }

    return result;
}